'use strict';

var _ = require('lodash');
var ApplicableDatesChartDataService = function ApplicableDatesChartDataService() {
  function getAllSelectedData(selectedComparison, category, hostHighestFbc) {
    var selectedRow = [];
    if (category === 'TACTICAL') {
      _.forEach(selectedComparison, function (data) {
        if (data.fareBasisCode !== hostHighestFbc) {
          selectedRow.push(data);
          data.selected = true;
        } else {
          data.selected = false;
        }
      });
    } else {
      makeApplicableSelectionDeselection(selectedComparison, hostHighestFbc);
      _.forEach(selectedComparison, function (data) {
        if (data.selected) {
          selectedRow.push(data);
        }
      });
    }
    checkDefaultSelection(selectedComparison, selectedRow);
    return selectedRow;
  }
  function makeApplicableSelectionDeselection(selectedComparison, hostHighestFbc) {
    _.forEach(selectedComparison, function (data) {
      if (data.fareBasisCode === hostHighestFbc && data.selectedCompetitorKey === undefined) {
        data.selected = false;
      } else {
        var comp = getMappedCompetitor(selectedComparison, data);
        if (comp !== undefined) {
          if (data.selected !== data.previousState) {
            comp.selected = data.selected;
            data.previousState = data.selected;
            comp.previousState = comp.selected;
          } else if (comp.selected !== comp.previousState) {
            data.selected = comp.selected;
            data.previousState = data.selected;
            comp.previousState = comp.selected;
          }
        }
      }
    });
  }
  function getMappedCompetitor(selectedComparison, data) {
    return _.find(selectedComparison, function (key) {
      if (key.competitorKey !== undefined && key.competitorKey === data.selectedCompetitorKey && key.hostRbd === data.rbd) {
        return key;
      }
    });
  }
  function checkDefaultSelection(selectedComparison, selectedRow) {
    if (!_.some(selectedComparison, {
      'selected': true
    })) {
      _.map(selectedComparison, function (data) {
        if (data.isDefaultSelection) {
          data.selected = true;
          data.previousState = true;
          selectedRow.push(data);
        }
      });
    }
  }
  function getCompChartData(selectedBenchmark, hostCarrier) {
    var compChartData = [];
    _.forEach(selectedBenchmark, function (data) {
      if (!_.isNil(data) && data.carrier !== hostCarrier) {
        compChartData.push(data);
      }
    });
    return compChartData;
  }
  function getHostChartData(selectedBenchmark, hostCarrier) {
    var hostChartData = [];
    _.forEach(selectedBenchmark, function (data) {
      if (!_.isNil(data) && data.carrier === hostCarrier) {
        hostChartData.push(data);
      }
    });
    return hostChartData;
  }
  return {
    getAllSelectedData: getAllSelectedData,
    getCompChartData: getCompChartData,
    getHostChartData: getHostChartData
  };
};
module.exports = ApplicableDatesChartDataService;